import CavernDecorator from "./CavernDecorator";
import * as FTN from "../../fixture/FixtureTypeNames"
import { FixtureSpriteColorArray, FixtureSpriteColors } from "../../fixture/FixtureSpriteColors";
import TileDecoratorTheme from "./TileDecoratorTheme";
import MersenneTwister from "../../math/MersenneTwister";

export default class TerrainLayerDecoratorConfig {
    constructor() {                
    }

    /**
     * 
     * @param {MersenneTwister} rng 
     * @returns {CavernDecorator[]}
     */
    getRandomLayerDecorator(rng) {

        const colorScheme1 = this.randomColorScheme(rng);
        const colorScheme2 = this.randomColorScheme(rng);

        return [
            new CavernDecorator(this.randomCeilingTheme(rng, colorScheme1), this.randomMidTheme(rng, colorScheme2), this.randomFloorTheme(rng, colorScheme2)),
            new CavernDecorator(this.randomCeilingTheme(rng, colorScheme2), null, this.randomFloorTheme(rng, colorScheme1)), 
        ];
    }

    /**
     * @private
     * @param {MersenneTwister} rng 
     * @param {string[]} colorScheme 
     * @returns {TileDecoratorTheme}
     */
    randomCeilingTheme(rng, colorScheme) {

        const fixtureTypeNames = FTN.CEILING[rng.randomInt(FTN.CEILING.length)];

        return new TileDecoratorTheme(fixtureTypeNames, colorScheme, 2);
    }
    /**
     * @private
     * @param {MersenneTwister} rng 
     * @param {string[]} colorScheme 
     * @returns {TileDecoratorTheme}
     */
    randomMidTheme(rng, colorScheme) {
        const fixtureTypeNames = FTN.MID[rng.randomInt(FTN.MID.length)];

        return new TileDecoratorTheme(fixtureTypeNames, colorScheme, 8); // <-- Div by 8 for mid. We don't want too many
    }
    /**
     * @private
     * @param {MersenneTwister} rng 
     * @param {string[]} colorScheme 
     * @returns {TileDecoratorTheme}
     */
    randomFloorTheme(rng, colorScheme) {
        const fixtureTypeNames = FTN.FLOOR[rng.randomInt(FTN.FLOOR.length)];

        return new TileDecoratorTheme(fixtureTypeNames, colorScheme, 2);
    }

    /**
     * @private
     * @param {MersenneTwister} rng 
     * @returns {string[]}
     */
    randomColorScheme(rng) {
        const colorScheme = [];

        colorScheme.push(this.functionRandomColor(rng));
        colorScheme.push(this.functionRandomColor(rng));
        colorScheme.push(this.functionRandomColor(rng));

        return colorScheme;
    }

    /**
     * @private
     * @param {MersenneTwister} rng 
     * @returns {string}
     */
    functionRandomColor(rng) {
        return FixtureSpriteColorArray[rng.randomInt(FixtureSpriteColorArray.length)];
    }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getDirtLayerDecorators() {

    //     const colorSchemes = [
    //         FixtureSpriteColors.GRAY_DARK_BROWN3_DARKER_BROWN,
    //         FixtureSpriteColors.BLUE_DARK_BLUE_LIGHT_GRAY,
    //         FixtureSpriteColors.DARK_GRAY_ORANGE_RED_BLUE, 
    //         FixtureSpriteColors.TAN_GREEN_DARK_GRAY_LIGHT_PURPLE1
    //     ];

    //     const colorSchemes2 = [
    //         FixtureSpriteColors.GRAY_DARK_BROWN3_DARKER_BROWN,
    //         FixtureSpriteColors.BLUE_DARK_BLUE_LIGHT_GRAY,
    //     ];

    //     const themeVinesTop = new TileDecoratorTheme(FTN.VINES_TOP, colorSchemes, 2);
    //     const themeVinesPartial = new TileDecoratorTheme(FTN.VINES_PARTIAL, colorSchemes2, 8);
    //     const themeGrass = new TileDecoratorTheme(FTN.FLOOR_GRASS, colorSchemes, 2);
    //     const themePlants = new TileDecoratorTheme(FTN.FLOOR_PLANTS, colorSchemes2, 2);

    //     return [
    //         new CavernDecorator(themeVinesTop, themeVinesPartial, themeGrass),
    //         new CavernDecorator(themeVinesPartial, themeVinesPartial, themePlants),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getGreySandstoneLayerDecorators() {

    //     const vineColors = [
    //         FixtureSpriteColors.GREEN_BLUE_LIME_GREEN1_BLUE,
    //         FixtureSpriteColors.LIGHT_PINK_DARK_PURPLE_YELLOW
    //     ]

    //     const colorSchemes = [
    //         FixtureSpriteColors.LIGHT_BROWN2_REDDISH_BROWN_ORANGE_BROWN,
    //         FixtureSpriteColors.YELLOW_ORANGE_DARK_GREEN2,
    //         FixtureSpriteColors.LIGHT_PINK_DARK_PURPLE_YELLOW
    //     ];

    //     const themeVinesTop = new TileDecoratorTheme(FTN.VINES_TOP, vineColors, 2);
    //     const themeVinesPartial = new TileDecoratorTheme(FTN.VINES_PARTIAL, colorSchemes, 8);
    //     const themePlants = new TileDecoratorTheme(FTN.FLOOR_PLANTS, colorSchemes, 2);
    //     const themeMushrooms = new TileDecoratorTheme(FTN.FLOOR_MUSHROOM, colorSchemes, 2);

    //     return [
    //         new CavernDecorator(themeVinesTop, null, themeMushrooms),
    //         new CavernDecorator(null, themeVinesPartial, themePlants),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getBlueStoneLayerDecorators() {

    //     const stalagColors = [
    //         FixtureSpriteColors.ORANGE_ORANGE_YELLOW_DARK_ORANGE,
    //         FixtureSpriteColors.BROWNISH_GREEN_DARK_RED_SUPER_DARK_GREEN
    //     ]

    //     const flowerColors = [
    //         FixtureSpriteColors.TAN_GREEN_DARK_GRAY_LIGHT_PURPLE1,
    //         FixtureSpriteColors.GREEN_BLUE_LIME_GREEN1_BLUE
    //     ];


    //     const grassColorSchemes = [
    //         FixtureSpriteColors.DARK_BROWN_RED_DARK_RED_RED
    //     ];


    //     const themeTop = new TileDecoratorTheme(FTN.STALACTITES, stalagColors, 2);
    //     const themeMid = new TileDecoratorTheme(FTN.WALL_FLOWERS, flowerColors, 8);
    //     const themeFloor1 = new TileDecoratorTheme(FTN.STALAGMITES, stalagColors, 2);
    //     const themeFloor2 = new TileDecoratorTheme(FTN.FLOOR_GRASS, grassColorSchemes, 2);

    //     return [
    //         new CavernDecorator(themeTop, themeMid, themeFloor2),
    //         new CavernDecorator(null, themeMid, themeFloor1),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getGreyOrangeGraniteLayerDecorators() {

    //     const stalagColors = [
    //         FixtureSpriteColors.DARK_BROWN1_GREY_ORANGE_BROWN,
    //         FixtureSpriteColors.LIGHT_BROWN2_REDDISH_BROWN_ORANGE_BROWN
    //     ]

    //     const vineColors = [
    //         FixtureSpriteColors.LIME_GREEN2_BROWNISH_GREEN_DARK_RED_ORANGE,
    //         FixtureSpriteColors.LIGHT_PURPLE2_DARKER_PURPLE_LIGHT_YELLOW
    //     ];

    //     const grassColorSchemes = [
    //         FixtureSpriteColors.GREY_BLUE_GREEN_LIME_GREEN2_YELLOW_BROWN,
    //         FixtureSpriteColors.DARK_ORANGE_DARK_GRAY_LIGHTER_GRAY
    //     ];

    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, stalagColors, 2);
    //     const topVines = new TileDecoratorTheme(FTN.VINES_TOP, vineColors, 2);
    //     const grassTheme = new TileDecoratorTheme(FTN.FLOOR_GRASS, grassColorSchemes, 2);

    //     return [
    //         new CavernDecorator(ceilingPokies, null, grassTheme),
    //         new CavernDecorator(topVines, null, grassTheme),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getArkoseLayerDecorators() {

    //     const stalagColors = [
    //         FixtureSpriteColors.DARK_GRAY_LIGHT_GRAY_DARK_RED_PINK,
    //         FixtureSpriteColors.GREY_BLUE_GREEN_LIME_GREEN2_YELLOW_BROWN
    //     ]
    //     const ceilingPokieColors = [
    //         FixtureSpriteColors.DARK_GRAY_LIGHT_GRAY_DARK_RED_PINK,
    //         FixtureSpriteColors.GREEN_DARK_GREEN1_DARK_GREEN2
    //     ]

    //     const holeColors = [
    //         FixtureSpriteColors.LIGHT_BROWN2_REDDISH_BROWN_ORANGE_BROWN,
    //         FixtureSpriteColors.ORANGE_BROWN_REDDISH_BROWN_LIGHT_BROWN2
    //     ];

    //     const floorPokiesColors = [
    //         FixtureSpriteColors.BLUE_DARK_BLUE_LIGHT_GRAY,
    //         FixtureSpriteColors.DARK_BROWN1_GREY_ORANGE_BROWN
    //     ];

    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, ceilingPokieColors, 1);
    //     const stalactites = new TileDecoratorTheme(FTN.STALACTITES, stalagColors, 2);
    
    //     const wallHoles = new TileDecoratorTheme(FTN.WALL_HOLES, holeColors, 5);
    //     const floorPokies = new TileDecoratorTheme(FTN.FLOOR_POKIES, floorPokiesColors, 1);

    //     return [
    //         new CavernDecorator(ceilingPokies, wallHoles, floorPokies),
    //         new CavernDecorator(stalactites, null, floorPokies),
    //     ];
    // }


    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getPurpleGreyGraniteLayerDecorators() {

    //     const stalagColors = [
    //         FixtureSpriteColors.DARK_GRAY_LIGHT_GRAY_DARK_RED_PINK,
    //         FixtureSpriteColors.GREY_BLUE_GREEN_LIME_GREEN2_YELLOW_BROWN
    //     ]
    //     const ceilingGrassColors = [
    //         FixtureSpriteColors.BLUE_DARK_BLUE_PURPLE,
    //         FixtureSpriteColors.GREEN_DARK_GREEN1_DARK_GREEN2
    //     ]

    //     const floorSpikeColors = [
    //         FixtureSpriteColors.LIME_GREEN2_BROWNISH_GREEN_DARK_RED_ORANGE,
    //         FixtureSpriteColors.ORANGE_ORANGE_YELLOW_DARK_ORANGE
    //     ];

    //     const ceilingGrass = new TileDecoratorTheme(FTN.CEILING_GRASS, ceilingGrassColors, 1);
    //     const stalactites = new TileDecoratorTheme(FTN.STALACTITES, stalagColors, 2);
    
    //     const floorSpikes = new TileDecoratorTheme(FTN.FLOOR_SPIKES, floorSpikeColors, 1);

    //     return [
    //         new CavernDecorator(ceilingGrass, null, floorSpikes),
    //         new CavernDecorator(stalactites, null, floorSpikes),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getGreenQuartzLayerDecorators() {

    //     const vineColors = [
    //         FixtureSpriteColors.ORANGE_ORANGE_YELLOW_DARK_ORANGE,
    //         FixtureSpriteColors.TEAL_LIGHT_BLUE1_PALE_AQUA
    //     ]
    //     const ceilingPokiesColors = [
    //         FixtureSpriteColors.SKY_BLUE_PALE_BLUE_LIGHT_BLUE2,
    //         FixtureSpriteColors.TEAL_LIGHT_BLUE1_PALE_AQUA
    //     ]

    //     const tallGrassColors = [
    //         FixtureSpriteColors.LIGHT_PURPLE1_ORANGE_RED_PURPLE,
    //         FixtureSpriteColors.ORANGE_RED_VERY_DARK_RED_SUPER_DARK_RED
    //     ];

    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, ceilingPokiesColors, 1);
    //     const vineTops = new TileDecoratorTheme(FTN.VINES_TOP, vineColors, 2);
    
    //     const tallGrass = new TileDecoratorTheme(FTN.TALL_GRASS, tallGrassColors, 2);

    //     return [
    //         new CavernDecorator(ceilingPokies, null, tallGrass),
    //         new CavernDecorator(vineTops, null, tallGrass),
    //     ];
    // }


    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getDarkIronStoneLayerDecorators() {

    //     const stalactiteColors = [
    //         FixtureSpriteColors.GREEN_BLUE_LIME_GREEN1_BLUE,
    //         FixtureSpriteColors.YELLOW_ORANGE_DARK_GREEN2
    //     ]

    //     const flowerColors = [
    //         FixtureSpriteColors.SKY_BLUE_PALE_BLUE_LIGHT_BLUE2,
    //         FixtureSpriteColors.LIGHT_PINK_DARK_PURPLE_YELLOW
    //     ];
    //     const mushroomColors = [
    //         FixtureSpriteColors.TAN_GREEN_DARK_GRAY_LIGHT_PURPLE1,
    //         FixtureSpriteColors.BLUE_ORANGE_YELLOW_PURPLE
    //     ];

    //     const ceilingStalagtites = new TileDecoratorTheme(FTN.STALACTITES, stalactiteColors, 2);
    //     ///////const vineTops = new TileDecoratorTheme(FTN.VINES_TOP, vineColors, 2);
    
    //     const flowers = new TileDecoratorTheme(FTN.FLOWERS, flowerColors, 2);
    //     const mushrooms = new TileDecoratorTheme(FTN.FLOOR_MUSHROOM, mushroomColors, 2);

    //     return [
    //         new CavernDecorator(ceilingStalagtites, null, flowers),
    //         new CavernDecorator(ceilingStalagtites, null, mushrooms),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getRedSunstoneLayerDecorators() {

    //     const ceilingColors = [
    //         FixtureSpriteColors.LIGHT_BLUE_GREEN_BROWNISH_GREEN_LIME_GREEN2,
    //         FixtureSpriteColors.LIGHT_PINK_DARK_PURPLE_YELLOW
    //     ]

    //     const plantColors = [
    //         FixtureSpriteColors.LIGHT_YELLOW_YELLOW_ORANGE_YELLOW,
    //         FixtureSpriteColors.TEAL_LIGHT_BLUE1_PALE_AQUA
    //     ];
    //     const grassColors = [
    //         FixtureSpriteColors.SKY_BLUE_PALE_BLUE_LIGHT_BLUE2,
    //         FixtureSpriteColors.LIGHT_PURPLE1_ORANGE_RED_PURPLE
    //     ];

    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, ceilingColors, 2);
    //     const ceilingSpikes = new TileDecoratorTheme(FTN.CEILING_SPIKES, ceilingColors, 2);
    
    //     const curvedPlants = new TileDecoratorTheme(FTN.CURVED_PLANTS, plantColors, 2);
    //     const tallGrass = new TileDecoratorTheme(FTN.TALL_GRASS, grassColors, 2);

    //     return [
    //         new CavernDecorator(ceilingPokies, null, curvedPlants),
    //         new CavernDecorator(ceilingSpikes, null, tallGrass),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getPinkGraniteLayerDecorators() {

    //     const ceilingColors = [
    //         FixtureSpriteColors.LIGHT_YELLOW_YELLOW_ORANGE_YELLOW,
    //         FixtureSpriteColors.SKY_BLUE_PALE_BLUE_LIGHT_BLUE2
    //     ]

    //     const mushroomColors = [
    //         FixtureSpriteColors.DARKER_PURPLE_LIGHT_PURPLE2_LIGHT_YELLOW,
    //         FixtureSpriteColors.PURPLE_VERY_DARK_RED_SUPER_DARK_RED
    //     ];
    //     const pokiesColors = [
    //         FixtureSpriteColors.YELLOW_ORANGE_DARK_GREEN2,
    //         FixtureSpriteColors.LIME_GREEN1_DARK_BLUE_DARK_GRAY
    //     ];

    //     const ceilingStalctites = new TileDecoratorTheme(FTN.STALACTITES, ceilingColors, 2);
    //     const ceilingVines = new TileDecoratorTheme(FTN.VINES_TOP, ceilingColors, 2);
    
    //     const floorMushrooms = new TileDecoratorTheme(FTN.FLOOR_MUSHROOM, mushroomColors, 2);
    //     const floorPokies = new TileDecoratorTheme(FTN.FLOOR_POKIES, pokiesColors, 2);

    //     return [
    //         new CavernDecorator(ceilingStalctites, null, floorMushrooms),
    //         new CavernDecorator(ceilingVines, null, floorPokies),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getBlueQuartzLayerDecorators() {

    //     const ceilingGrassColors = [
    //         FixtureSpriteColors.LIGHT_BROWN2_BROWN3_YELLOW_BROWN,
    //         FixtureSpriteColors.LIGHT_YELLOW_YELLOW_ORANGE_YELLOW
    //     ]
    //     const ceilingPokiesColors = [
    //         FixtureSpriteColors.DARK_GRAY_ORANGE_RED_BLUE,
    //         FixtureSpriteColors.DARK_GRAY_LIGHT_PURPLE1_TAN_GREEN
    //     ]

    //     const grassColors = [
    //         FixtureSpriteColors.DARK_GRAY_ORANGE_RED_BLUE,
    //         FixtureSpriteColors.ORANGE_BROWN_REDDISH_BROWN_LIGHT_BROWN2
    //     ];
    //     const plantsColors = [
    //         FixtureSpriteColors.YELLOW_ORANGE_DARK_GREEN2,
    //         FixtureSpriteColors.VERY_DARK_GREEN_TAN_WHITE_YELLOW
    //     ];

    //     const ceilingGrass = new TileDecoratorTheme(FTN.CEILING_GRASS, ceilingGrassColors, 2);
    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, ceilingPokiesColors, 2);
    
    //     const floorGrass = new TileDecoratorTheme(FTN.FLOOR_GRASS, grassColors, 2);
    //     const floorPlants = new TileDecoratorTheme(FTN.FLOOR_PLANTS, plantsColors, 2);

    //     return [
    //         new CavernDecorator(ceilingGrass, null, floorGrass),
    //         new CavernDecorator(ceilingPokies, null, floorPlants),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getBrownBasaltLayerDecorators() {

    //     const ceilingSpikesColors = [
    //         FixtureSpriteColors.SKY_BLUE_BROWNISH_GREEN_LIME_GREEN2,
    //         FixtureSpriteColors.LIGHT_PURPLE1_ORANGE_RED_PURPLE
    //     ]
    //     const ceilingStalagtiteColors = [
    //         FixtureSpriteColors.LIME_GREEN2_BROWNISH_GREEN_DARK_RED_ORANGE,
    //         FixtureSpriteColors.LIGHT_BLUE_GREEN_BROWNISH_GREEN_LIME_GREEN2
    //     ]

    //     const grassColors = [
    //         FixtureSpriteColors.ORANGE_YELLOW_YELLOW_BROWN_TAN_GREEN,
    //         FixtureSpriteColors.GREY_BLUE_GREEN_LIME_GREEN2_YELLOW_BROWN
    //     ];
    //     const stalagmitesColors = [
    //         FixtureSpriteColors.PURPLE_VERY_DARK_RED_SUPER_DARK_RED,
    //         FixtureSpriteColors.ORANGE_RED_VERY_DARK_RED_SUPER_DARK_RED
    //     ];

    //     const ceilingSpikes = new TileDecoratorTheme(FTN.CEILING_SPIKES, ceilingSpikesColors, 2);
    //     const ceilingStalagtites = new TileDecoratorTheme(FTN.STALACTITES, ceilingStalagtiteColors, 2);
    
    //     const floorStalagmites = new TileDecoratorTheme(FTN.STALAGMITES, stalagmitesColors, 2);
    //     const floorGrass = new TileDecoratorTheme(FTN.FLOOR_GRASS, grassColors, 2);

    //     return [
    //         new CavernDecorator(ceilingSpikes, null, floorStalagmites),
    //         new CavernDecorator(ceilingStalagtites, null, floorGrass),
    //     ];
    // }

    // /**
    //  * @returns {Array.<CavernDecorator>}
    //  */
    // getDarkGreenSerpentineLayerDecorators() {

    //     const ceilingSpikesColors = [
    //         FixtureSpriteColors.DARK_GRAY_DARK_ORANGE_LIGHTER_GRAY,
    //         FixtureSpriteColors.TEAL_LIGHT_BLUE1_PALE_AQUA
    //     ]
    //     const ceilingPokiesColors = [
    //         FixtureSpriteColors.DARK_BROWN_RED_DARK_RED_RED,
    //         FixtureSpriteColors.DARK_GRAY_ORANGE_RED_BLUE
    //     ]

    //     const grassColors = [
    //         FixtureSpriteColors.SKY_BLUE_PALE_BLUE_LIGHT_BLUE2,
    //         FixtureSpriteColors.LIGHT_BROWN2_REDDISH_BROWN_ORANGE_BROWN
    //     ];
    //     const curvedPlantsColors = [
    //         FixtureSpriteColors.ORANGE_BROWN_REDDISH_BROWN_LIGHT_BROWN2,
    //         FixtureSpriteColors.DARKER_PURPLE_LIGHT_PURPLE2_LIGHT_YELLOW
    //     ];

    //     const ceilingPokies = new TileDecoratorTheme(FTN.CEILING_POKIES, ceilingPokiesColors, 2);
    //     const ceilingSpikes = new TileDecoratorTheme(FTN.CEILING_SPIKES, ceilingSpikesColors, 2);
    
    //     const floorGrass = new TileDecoratorTheme(FTN.FLOOR_GRASS, grassColors, 2);
    //     const floorCurvedPlants = new TileDecoratorTheme(FTN.CURVED_PLANTS, curvedPlantsColors, 2);

    //     return [
    //         new CavernDecorator(ceilingSpikes, null, floorCurvedPlants),
    //         new CavernDecorator(ceilingPokies, null, floorGrass),
    //     ];
    // }
}